import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { PavedRoadAssetService } from '#/app/shared/services/api/paved-road-asset.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies a paved road asset exists and belongs to the tenant in the route.
 * Prevents route matching if the asset doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const pavedRoadAssetAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const pavedRoadAssetService = inject(PavedRoadAssetService);
  const assetIdParam = _currentSnapshot?.paramMap.get('assetId') ?? '';

  return resolveResourceAccessGuardResult(assetIdParam, (assetIdSignal) =>
    pavedRoadAssetService.pavedRoadAssetResource(
      assetIdSignal as Signal<string>,
    ),
  );
};
